/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_DescriptionInputs */

const et_blog_description = /** @type {(inputs: Blog_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loe ScalingWebsi uusimaid artikleid, teadmisi ja uuendusi. Veebidisaini nõuanded, arenduse parimad praktikad ja valdkonna uudised.`)
};

const en_blog_description = /** @type {(inputs: Blog_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Read ScalingWebs' latest articles, insights, and updates. Web design tips, development best practices, and industry news.`)
};

/**
* | output |
* | --- |
* | "Read ScalingWebs' latest articles, insights, and updates. Web design tips, development best practices, and industry news." |
*
* @param {Blog_DescriptionInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const blog_description = /** @type {((inputs?: Blog_DescriptionInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_DescriptionInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_blog_description(inputs)
	return en_blog_description(inputs)
});